import { createSlice } from "@reduxjs/toolkit";
import { updateCaseCredit } from "@custom/rtk-apis/Setting/creditForCaseToCase/updateCaseCredit";

const initialState = {
  status: "",
  result: {},
  msg: "",
  loading: false,
  error: ""
};

const updateCaseCreditSlice = createSlice({
  name: "updateCaseCreditSlice",
  initialState,
  reducers: {
    clearUpdateCaseCreditState: (state) => {
      state.status = '';
      state.result = {};
      state.msg = '';
      state.loading = false;
      state.error = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCaseCredit.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCaseCredit.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(updateCaseCredit.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string;
        state.status = "FAILED";
      });
  }
});

export default updateCaseCreditSlice.reducer;
export const { clearUpdateCaseCreditState } = updateCaseCreditSlice.actions;
